import {
  Alert,
  Backdrop,
  Box,
  CircularProgress,
  Container,
  Grid,
  Icon,
  Snackbar,
  Typography,
  Button,
  Divider,
  // TextField,
  Stepper,
  Step,
  StepLabel,
  Stack,
  // CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  TextField,
  MenuItem,
  FormControl,
  InputAdornment,
  IconButton,
  AppBar,
  Toolbar,
  Paper,
} from "@mui/material";
import { useEffect, useState } from "react";
import CheckoutFooter from "../components/footer";
import AppConfig from "../../appConfig";
import axios from "../../axios";
import usePageTitle from "../pageTitle";
import { useNavigate, useParams } from "react-router-dom";

function StoreFront() {
  const [pageTitle, setPageTitle] = useState("Laddar Websites");
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  // const [open, setOpen] = useState(false);
  // const [errorMsg, setErrMsg] = useState("");
  // const [severity, setSeverity] = useState("");
  // const handleClose = () => {
  //   setOpen(false);
  //   setErrMsg("");
  // };

  const [webstore, setWebStore] = useState({});
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`checkout/webstore/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setPageTitle(`Laddar Africa | ${result.data.data.webstore.title}`);
            setWebStore(result.data.data.webstore);
            setCampaigns(result.data.data.campaigns);
          } else {
            // setSeverity("error");
            // setErrMsg(result.data.data.message);
            // setOpen(true);

            navigate("/error");
          }
        })
        .catch(() => {
          // setShowLoading(false);
          // setSeverity("error");
          // setErrMsg(
          //   `Unable to complete request. ${
          //     navigator.onLine ? "" : "Make sure you have an active internet connection"
          //   }`
          // );
          // setOpen(true);
          navigate("/error");
        });
    };

    fetchData();
  }, []);

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <Box mb={5}>
        <AppBar>
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
            >
              <img
                // src="https://placehold.co/600x400.png"
                src={`${AppConfig.api_media_url}${webstore.logo}`}
                alt="img"
                width="24px"
              />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {webstore.title}
            </Typography>
          </Toolbar>
        </AppBar>
      </Box> */}
      <Box mb={10}>
        <Box sx={{ width: "100%", maxWidth: "800px", margin: "0px auto" }}>
          <Box mt={5}>
            <Paper elevation={0}>
              <Box align="center" px={2}>
                <img
                  // src="https://placehold.co/600x400.png"
                  src={`${AppConfig.api_media_url}${webstore.logo}`}
                  alt="img"
                  width="50%"
                />
                <Box mt={2}>
                  <Typography variant="h6" fontSize={12}>
                    WELCOME TO
                  </Typography>
                </Box>
                <Box mt={1}>
                  <Typography variant="h4" fontWeight={300}>
                    {webstore.title}
                  </Typography>
                </Box>
              </Box>
              <Box mt={5} mb={5}>
                <Grid container spacing={3}>
                  <Grid item xs={6} md={6} lg={6}>
                    <Box
                      align="center"
                      onClick={() => {
                        window.location = `mailto:${webstore.email_address}`;
                      }}
                    >
                      <Icon color="primary">email</Icon>
                      <Typography variant="h6" fontSize={10}>
                        {webstore.email_address}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6} md={6} lg={6}>
                    <Box
                      align="center"
                      onClick={() => {
                        window.location = `tel:${webstore.phone_number}`;
                      }}
                    >
                      <Icon color="primary">phone</Icon>
                      <Typography variant="h6" fontSize={10}>
                        {webstore.phone_number}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              {/* <Box mt={5} mb={0}>
                &nbsp;
              </Box> */}
            </Paper>
          </Box>
          <Divider />
          <Box mt={5}>
            <Box
              mt={3}
              sx={{
                textAlign: { xs: "center" },
              }}
            >
              <Typography
                variant="h6"
                fontWeight={400}
                fontSize={14}
                color="primary"
              >
                BROWSE CATEGORIES
              </Typography>
            </Box>
            <Box mt={3} px={1}>
              <Grid container spacing={3}>
                {campaigns.map((campaign) => (
                  <Grid item xs={12} md={6} lg={6}>
                    <Box
                      my={4}
                      sx={{ height: "100%" }}
                      onClick={() => {
                        window.location.href = campaign.link;
                      }}
                    >
                      <Paper elevation={3} sx={{ height: "100%" }}>
                        <Box p={2} sx={{ height: "100%" }}>
                          <ListItem
                            key={
                              <Typography color="primary">
                                {campaign.reference}
                              </Typography>
                            }
                            sx={{ py: 1, px: 0 }}
                          >
                            <ListItemText
                              sx={{ mr: 2 }}
                              primary={
                                <Typography fontSize={14} fontWeight={600}>
                                  {campaign.title}
                                </Typography>
                              }
                              // secondary={
                              //   <Box mt={1}>
                              //     <Typography fontSize={12}>
                              //       <div
                              //         dangerouslySetInnerHTML={{
                              //           __html: campaign.description,
                              //         }}
                              //       />
                              //     </Typography>
                              //   </Box>
                              // }
                            />
                            <Box mt={0}>
                              <ListItemIcon>
                                <Icon color="primary">arrow_forward_ios</Icon>
                              </ListItemIcon>
                            </Box>
                          </ListItem>
                        </Box>
                      </Paper>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        </Box>
      </Box>
      <CheckoutFooter />
    </>
  );
}

export default StoreFront;
